import React, { ReactElement } from 'react';
import Icon from '@components/Icon';
import { Network } from '@types';

interface NetworkIconProps {
  className?: string;
  variant: Network;
}

const NetworkIcon = ({
  className,
  variant,
}: NetworkIconProps): ReactElement => {
  switch (variant) {
    case Network.Ethereum:
      return <Icon.Ethereum className={className} />;
    case Network.CryptoOrg:
      return <Icon.CryptoOrg className={className} />;
    case Network.Cosmos:
      return <Icon.Cosmos className={className} />;
    case Network.Terra:
      return <Icon.Terra className={className} />;
    case Network.Juno:
      return <Icon.Juno className={className} />;
    case Network.Akash:
      return <Icon.Akash className={className} />;
    case Network.Canto:
      return <Icon.Canto className={className} />;
    case Network.Iris:
      return <Icon.Iris className={className} />;
    case Network.Celestia:
      return <Icon.Celestia className={className} />;
    case Network.Cronos:
    default:
      return <Icon.Cronos className={className} />;
  }
};

export default NetworkIcon;
